module.exports = __webpack_public_path__ + "img/img0.2cb9a5a7.jpg";